// extracted by mini-css-extract-plugin
module.exports = {"text":"ResetPassword_text__2_eBh","fieldset":"ResetPassword_fieldset__194bD"};